import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'

export const EditNonUserEmailModalBody: React.FC = () => {
  return (
    <>
      <CIMSFormItem
        name={'label'}
        label={'Label'}
        help={HelpMessage.Administration.NonUserEmails.Label}
      >
        <Input />
      </CIMSFormItem>
      <DescriptionFormItem entityName="Non User Email" />
      <CIMSFormItem
        name={'address'}
        label={'Email Address'}
        help={HelpMessage.Administration.NonUserEmails.Email}
        requiredMessage="Please enter an email address"
        emailMessage="Please enter a valid email address"
      >
        <Input />
      </CIMSFormItem>
    </>
  )
}

export interface EditNonUserEmailModalValues {
  label?: string | null
  description?: string | null
  address: string
}
